// extracted by mini-css-extract-plugin
export default {"delayedShow":"DynamicUI_delayedShow__fEJ3N","show":"DynamicUI_show__0AFCT","delayedTextColor":"DynamicUI_delayedTextColor__HvAH-","error":"DynamicUI_error__AGMtx"};